module.exports = __webpack_public_path__ + "static/img/benz_2.d8bc368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/benz_2.png
// module id = yJkr
// module chunks = 215